import styled from '@emotion/styled'
import React from 'react'
import useModal from '../hooks/useModal'
import {PALETTE} from '../styles/paletteV3'
import lazyPreload from '../utils/lazyPreload'
import IconLabel from './IconLabel'
import LinkButton from './LinkButton'

const DeleteAccountModal = lazyPreload(
  () => import(/* webpackChunkName: 'DeleteAccountModal' */ './DeleteAccountModal')
)

const Hint = styled('div')({
  color: PALETTE.SLATE_600,
  fontSize: 13,
  marginTop: 8
})

const DeleteAccount = () => {
  const {togglePortal, modalPortal} = useModal()
  return (
    React.createElement(React.Fragment, null
      , React.createElement('div', null
        , React.createElement(LinkButton, {
          'aria-label': "Click to permanently delete your account."     ,
          palette: "red",
          onClick: togglePortal,}

          , React.createElement(IconLabel, { iconLarge: true, icon: "remove_circle", label: "Delete Account" ,} )
        )
        , React.createElement(Hint, null
          , React.createElement('b', null, "Note"), ": " , 'This can’t be undone.'
        )
      )
      , modalPortal(React.createElement(DeleteAccountModal, null ))
    )
  )
}

export default DeleteAccount
